var map = {
	"./SM6_MASK_L.png": "b6ed",
	"./SM6_MASK_M.png": "cf30",
	"./applepay_logo-min.png": "a515",
	"./collect-free-masks-1.png": "3a74",
	"./collect-free-masks-2.png": "6e18",
	"./contactUs/email-icon.svg": "6b8b",
	"./contactUs/telephone-icon.svg": "3125",
	"./credit-card-apple.png": "ee93",
	"./credit-card-google.png": "6b22",
	"./credit-card-new.png": "fad7",
	"./credit-card.png": "9aa8",
	"./dbs_paylah_app.png": "d272",
	"./googlepay_logo-min.png": "c53c",
	"./home-collect-free-masks.png": "4752",
	"./home-illustration.png": "8ca4",
	"./home-illustration1.svg": "c8df",
	"./home-locate-vending-machines.png": "b287",
	"./home-pre-order-additional-masks.png": "46a9",
	"./home-size-chart.png": "0ae4",
	"./homePage/home-page-mask-img-desktop.png": "57fd",
	"./homePage/home-page-mask-img-mobile.png": "48b8",
	"./locate-pin-icon.png": "1840",
	"./locate-stock-icon.png": "f8ac",
	"./locate-vending-machine-footer-SM04.png": "dcc5",
	"./locate-vending-machine-footer-SM06.png": "69ba",
	"./locate-vending-machine-footer-old.png": "88dc",
	"./locate-vending-machine-footer.png": "8f82",
	"./mask-product.png": "d13d",
	"./mobile-login-logo.png": "55d7",
	"./ocbcpao_logo.png": "1c1f",
	"./oops.png": "5edf",
	"./payanyone.png": "0f45",
	"./paylah.png": "9439",
	"./paynow.png": "b833",
	"./sm3_maskFIT_l.png": "7912",
	"./sm3_maskFIT_m.png": "177f",
	"./sm3_maskFIT_s.png": "16cd",
	"./sm3_maskFIT_xl.png": "4212",
	"./sm4_livinguard_l.png": "80a3",
	"./sm4_livinguard_m.png": "efa4",
	"./sm4_livinguard_s.png": "56d9",
	"./sm4_livinguard_xl.png": "9147",
	"./stay-prepared-logo.svg": "0c46",
	"./staymasked-logo.svg": "596c",
	"./temasek-foundation-logo.svg": "a72e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";